import React from 'react';
import FlowSteps from '../FlowSteps';
import { AppRoutePath } from 'Pages/routes';

const steps = [
  {
    label: 'Add ons',
    stepNumber: 1,
    getPath: (
      serviceProviderId: string,
      serviceOfferingUid: string,
    ) => AppRoutePath.APPOINTMENT_REQUEST_V3_CUSTOMER_INPUTS
      .replace('[serviceProviderId]', serviceProviderId)
      .replace('[serviceOfferingUid]', serviceOfferingUid)
  },
  {
    label: 'Date & Time',
    stepNumber: 2,
    getPath: (
      serviceProviderId: string,
      serviceOfferingUid: string,
    ) => AppRoutePath.APPOINTMENT_REQUEST_V3_SELECT_START_DATE_TIME
      .replace('[serviceProviderId]', serviceProviderId)
      .replace('[serviceOfferingUid]', serviceOfferingUid)
  },
  {
    label: 'Review',
    stepNumber: 3,
  },
];

type RequestAppointmentStepsProps = {
  currentStep: number;
  innerClass?: string;
  serviceProviderId?: string,
  serviceOfferingUid?: string,
}

const RequestAppointmentSteps: React.FC<RequestAppointmentStepsProps> = ({
  currentStep,
  innerClass = '',
  serviceProviderId,
  serviceOfferingUid,
}) => {
  return (
    <FlowSteps
      currentStep={currentStep}
      innerClass={innerClass}
      steps={steps}
      getHrefForStep={n => {
        if (serviceProviderId && serviceOfferingUid) {
          const step = steps.find(s => s.stepNumber === n);
          if (step && step.getPath) {
            const url = step.getPath(serviceProviderId, serviceOfferingUid);
            return url;
          }
        }

        return null;
      }}
    />
  );
};

export default RequestAppointmentSteps;

